<!-- <div class="kit_hml" *ngIf="exibirKitHml">
  <p>Kit Homologação</p>
  <div class="kit_hml_datas">
    <button (click)="kitHml(1)">Durante inscrição</button>
    <button (click)="kitHml(2)">Após período de inscrição</button>
    <button (click)="kitHml(3)">Dia do sorteio</button>
    <button (click)="kitHml(4)">Após sorteio</button>
    <button (click)="kitHml(5)">Participando</button>
    <button (click)="kitHml(6)">Não Participando</button>
  </div>
</div> -->

<button class="ajuda" (click)="irParaAjuda()">
  <span>Precisa de </span>
  Ajuda<span>?</span>
</button>

<main class="lp-promocional" [ngClass]="{ 'promocional--participando': participando }">
  <header class="lp-promocional__header">
    <a routerLink="['/']">
      <img class="logo__image" src="assets/images/logos/lovers_promo.png" alt="Lovers Logo" />
    </a>

    <nav class="header__nav">
      <ul class="header__nav__list">
        <li class="list__item" *ngFor="let menuItem of menuItems" [hidden]="
            !(
              participando === menuItem.somenteParticipante ||
              !menuItem.somenteParticipante
            )
          " [ngClass]="{ 'item--destacado': menuItem.destacado }">
          <a class="item__link" (click)="scrollTo(menuItem.irPara)">{{
            menuItem.label
            }}</a>
        </li>
      </ul>
    </nav>

    <div class="header__acoes">
      <button class="participe__button" *ngIf="!participando && dataAtual < dataInicioSorteio && !obtendoMembro"
        type="button" (click)="participar()">
        Participar!
      </button>

      <button class="participe__button header__n-sorte" *ngIf="participando && !obtendoMembro" type="button"
        (click)="scrollTo('numeros-da-sorte')">
        Meus Nº da Sorte!
      </button>

      <i *ngIf="obtendoMembro" class="fa fa-spinner fa-spin fonte-colorida"></i>

      <img class="header__menu-icone" [ngClass]="{ 'menu-icone--aberto': menuMobileAberto }" [src]="
          menuMobileAberto
            ? 'assets/images/icons/times_promo.png'
            : 'assets/images/icons/hamburguer_promo.png'
        " (click)="menuMobileAberto = !menuMobileAberto" />
    </div>

    <a class="ecom__link" href="https://www.cacaushow.com.br/" target="_blank">
      <img class="ecom__logo" src="assets/images/logos/cs.png" alt="E-Commerce Cacau Show" />
    </a>
  </header>

  <div class="header__menu__mobile" [ngClass]="{'menu__mobile--ativado': menuMobileAberto}">
    <nav>
      <ul class="header__nav__list__mobile">
        <li class="list__item" *ngFor="let menuItem of menuItems" [hidden]="
            !(
              participando === menuItem.somenteParticipante ||
              !menuItem.somenteParticipante
            ) || menuItem.label === 'Meus Nºs da sorte'
          " [ngClass]="{ 'item--destacado': menuItem.destacado }">
          <a class="item__link" (click)="scrollTo(menuItem.irPara)">{{
            menuItem.label
            }}</a>
        </li>
      </ul>
    </nav>
  </div>

  <img src="assets/images/promocao/Namorados_LP_banner.jpg" alt="Promoção Namorados 2023" class="banner__image" />

  <img src="assets/images/promocao/Namorados_LP_Mobile-Banner.png" alt="Promoção Namorados 2023"
    class="banner__image__mobile" />

  <section id="numeros-da-sorte" class="meus-numeros" *ngIf="participando">
    <div class="lp-promocional__meus-numeros">
      <div>
        <img class="meus-numeros__premio" src="assets/images/promocao/namorados_numeros-sorte.png" />
      </div>
      <div class="meus__numeros_box">
        <article class="meus-numeros__container">
          <p class="meus-numeros__titulo">Meus números da sorte</p>
          <div class="meus-numeros__listagem" *ngIf="!obtendoNumerosSorte; else carregandoNumerosSorte">
            <div class="listagem__container" *ngFor="let compra of numerosSorte">
              <div class="listagem__item" *ngFor="
                  let bilhete of compra.sorteioParticipantesComprasDetalheModel
                " (click)="selecionarNumeroSorte(bilhete)">
                <p class="item__data">
                  {{ bilhete.data | date : "dd/MM/yyyy" }}
                </p>
                <div class="item__numeros">
                  <div>
                    <div class="numeros__numero" *ngFor="
                        let bilheteCompra of bilhete.sorteioParticipantesComprasBilhetesModel!;
                        let l = last
                      " [ngClass]="{ 'numero--sem-margem': l }">
                      <img class="numero__icone" src="assets/images/icons/coracao_pequeno-branco.png"
                        alt="Número da Sorte" />
                      <p class="numero__valor">
                        {{ bilheteCompra.serie }}-{{ bilheteCompra.number }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ng-template #carregandoNumerosSorte>
            <div class="meus-numeros__listagem">
              <ngx-skeleton-loader count="3" [theme]="{
                  'border-radius': '8px',
                  width: '100%',
                  height: '48px',
                  margin: '0 0 8px 0'
                }"></ngx-skeleton-loader>
            </div>
          </ng-template>

          <div class="sem-numeros" *ngIf="!obtendoNumerosSorte && numerosSorte.length === 0">
            <img class="sem-numeros__imagem" src="assets/images/icons/coracao_pequeno.png" alt="Sem número da sorte" />
            <p class="sem-numeros__texto">
              Você ainda não tem nenhum número da sorte.
            </p>
          </div>

          <p class="meus-numeros__explicacao">
            Somente as compras com um item de Namorados e valor mínimo de R$ 100,00
            geram número da sorte.
          </p>

          <p class="meus-numeros__explicacao-numeros">
            Não se preocupe! Se realizou uma compra nas últimas horas, em breve
            seu numero da sorte estará disponível.
          </p>
        </article>
        <!-- <div class="menus-numeros__codigo" *ngIf="dataAtual < dataInicioSorteio">
          <p class="codigo__texto">Tem um cupom com <b>código promocional</b>?</p>

          <button class="codigo__button" (click)="abrirModalGeracaoNumero()">
            <img class="codigo__button__icone" src="assets/images/icons/heroicons-outline_ticket.png"
              alt="Rasgadinha" />
            Gere o seu número da sorte aqui!
          </button>
        </div> -->
      </div>
    </div>
  </section>

  <section id="como-participar" class="lp-promocional__participar">
    <p class="participar__titulo">Como Participar</p>

    <div class="participar__instrucoes">
      <div class="instrucoes__instrucao">
        <img src="assets/images/promocao/KV_Namorados2023_Promo_PASSO1.png" class="instrucao__etapa" />

        <p class="instrucao__titulo">Compre</p>
        <p class="intrucao__descricao">
          <b>A cada R$ 100,00</b> em compras contendo um item da linha de Namorados,
          você
          <b>ganha 1 número da sorte para concorrer.</b>
        </p>

        <a class="outline__button" href="https://www.cacaushow.com.br/namorados-2023.html" target="_blank">Compre
          aqui</a>

        <button class="button__loja-proxima" type="button" (click)="exibirModalLocalizacao = true">
          <img src="assets/images/icons/bx_store.png" alt="Loja Próxima" class="button__icon" />
          ou encontre uma loja próxima
        </button>
      </div>

      <div class="instrucoes__instrucao">
        <img src="assets/images/promocao/KV_Namorados2023_Promo_PASSO2.png" class="instrucao__etapa" />

        <p class="instrucao__titulo">Cadastre-se</p>
        <p class="intrucao__descricao">
          Clique no botão <b>PARTICIPAR</b> e dê o aceite na promoção
          <b>para gerar seus números da sorte</b>. Campanha exclusiva Cacau
          Lover, cadastre-se!
        </p>

        <button *ngIf="!participando && !obtendoMembro"
          class="participar__button participe__button card__participe__button" (click)="participar()"
          [hidden]="dataAtual > dataInicioSorteio">
          Participar!
        </button>

        <p class="prazo-encerrado" *ngIf="dataAtual > dataInicioSorteio && !participando">
          <img class="prazo-encerrado__icone" src="assets/images/icons/timer-calendar_namorados.png" alt="" />
          <span class="prazo-encerrado__texto">Prazo encerrado</span>
        </p>

        <i *ngIf="obtendoMembro" class="fa fa-spinner fa-spin fonte-colorida"></i>

        <div class="membro__participando" *ngIf="participando && !obtendoMembro">
          <img class="etapa__participando" src="assets/images/icons/participando_check.png" />

          <p class="participando__texto">Você já está participando!</p>
        </div>
      </div>

      <div class="instrucoes__instrucao">
        <img src="assets/images/promocao/KV_Namorados2023_Promo_PASSO3.png" class="instrucao__etapa" />

        <p class="instrucao__titulo">Faça sua torcida!</p>
        <p class="intrucao__descricao">
          Você já está concorrendo a uma hospedagem no
          <b>Bendito Cacao Resort & Spa.</b> Continue comprando para
          aumentar ainda mais suas chances!
        </p>
      </div>
    </div>
  </section>

  <div id="premio">
    <img src="assets/images/promocao/Namorados_LP_banner_premio.jpg" alt="Promoção Namorados 2023"
      class="premio__banner" />

    <img src="assets/images/promocao/Namorados_LP_Mobile-Premio.jpg" alt="Promoção Namorados 2023"
      class="premio__banner__mobile" />
  </div>

  <article class="lp-promocional__progresso">
    <div class="premio__progresso">
      <h1 class="premio__titulo progresso__titulo">Calendário</h1>

      <div class="progresso__final">
        <img src="assets/images/promocao/Coracao_progress.png" class="progresso__icone" />

        <div class="progresso__descricao descricao__final">
          <p class="descricao__data">06 de julho</p>
          <p class="descricao__texto">sorteio</p>
        </div>
      </div>

      <div class="progresso__barra">
        <div>
          <meter class="barra barra--limite" id="progresso-limite" [value]="dataAtual" [min]="dataInicio"
            [max]="dataInicioSorteio"></meter>

          <div class="progresso__descricoes">
            <div class="progresso__descricao">
              <p class="descricao__data">22 de maio</p>
              <p class="descricao__texto">Lançamento</p>
            </div>

            <div class="progresso__descricao descricao__ultimo-dia">
              <p class="descricao__data">30 de junho</p>
              <p class="descricao__texto">
                Último dia para participar
              </p>
            </div>
          </div>
        </div>
        <div>
          <meter class="barra barra--sorteio" id="progresso-sorteio" [value]="dataAtual" [min]="dataInicioSorteio"
            [max]="dataFimSorteio"></meter>
        </div>
      </div>
    </div>

    <div class="ganhadores" *ngIf="dataAtual >= dataExibicaoResultado">
      <button class="ganhadores__button" (click)="abrirModalGanhadores()">
        <img class="button__imagem" src="assets/images/icons/coracao_pequeno.png" alt="Ganhadores" />
        <span class="button__texto"> VEJA OS GANHADORES </span>
      </button>
    </div>
  </article>

  <section class="lp-promocional__duvidas" id="duvidas">
    <header class="duvidas__header">
      <p class="header__titulo">Dúvidas</p>
    </header>

    <article class="duvidas__faq">
      <app-faq [faq]="faq" [verMais]="true"></app-faq>
    </article>

    <p class="duvidas__regulamento" id="regulamento">
      Para mais informações sobre a promoção, confira o
      <span class="regulamento__link" (click)="abrirModalRegulamento()">regulamento</span>
      completo.
    </p>
  </section>
</main>

<!-- Pop-ups -->

<div class="popups">
  <!-- Termos / Participar -->
  <lovers-popup [exibir]="exibirModalParticipar" (onClose)="exibirModalParticipar = false">
    <div class="popup__header" *ngIf="!participando">
      <p class="header__title">Promoção Namorados Lovers</p>
    </div>
    <div class="popup__body">
      <div *ngIf="!participando; else participandoPromocao">
        <p class="regulamento__titulo">Confira o regulamento e participe!</p>
        <div class="regulamento__container" id="regulamento-container" *ngIf="!obtendoRegulamento">
          <div class="regulamento__texto">
            <p *ngFor="let paragrafo of regulamento">
              {{ paragrafo }}
            </p>
          </div>
        </div>

        <div *ngIf="obtendoRegulamento">
          <ngx-skeleton-loader *ngFor="let width of ['95%', '100%', '90%', '100%', '33%']" count="1" [theme]="{
              'border-radius': '8px',
              width: width,
              height: '20px',
              'margin-bottom': '2px'
            }"></ngx-skeleton-loader>
        </div>

        <p class="regulamento__aceite">
          Ao clicar em “Participar”, você concorda com os termos e condições da
          promoção.
        </p>

        <button (click)="participarSorteio()" class="lovers-button modal__participar__button"
          [disabled]="participarBloqueado || carregandoParticipacao">
          Participar
          <i *ngIf="carregandoParticipacao" class="fa fa-spinner fa-spin"></i>
        </button>
      </div>

      <ng-template #participandoPromocao>
        <div class="modal__participando">
          <img src="assets/images/icons/check-gradiante-namorados.png" class="participando__sucesso" />

          <p class="participando__titulo">
            Parabéns! Agora você está participando da Promoção Dia dos Namorados!
          </p>

          <p class="participando__descricao">
            Junte números da sorte para concorrer e boa sorte! Feliz Hoje.
          </p>

          <button class="lovers-button modal__participar__button" (click)="exibirModalParticipar = false">
            Vamos Lá!
          </button>
        </div>
      </ng-template>
    </div>
  </lovers-popup>

  <!-- Geração de Número da Sorte por Rasgadinha -->
  <lovers-popup [exibir]="exibirModalGeracaoNumero" (onClose)="exibirModalGeracaoNumero = false" tamanho="pequeno">
    <div class="popup__header" *ngIf="!numeroGerado">
      <p class="header__title numero-sorte__title">
        Gere o seu número da sorte
      </p>
    </div>
    <div class="popup__body">
      <div *ngIf="!numeroGerado; else numeroGeradoComSucesso">
        <p>
          Digite o código que você recebeu para gerar o seu número da sorte!
        </p>
        <form class="form__numero-sorte" [formGroup]="numeroSorteForm" (submit)="gerarNumeroSorte()">
          <div>
            <input class="promocional__input" formControlName="codigo" placeholder="Digite o código" type="text" />
            <small class="error" *ngIf="codigoInvalido">Código inválido</small>
          </div>
          <button class="lovers-button numero-sorte__button" [ngClass]="{ disabled: gerandoNumeroSorte }" type="submit">
            Gerar Número
            <i *ngIf="gerandoNumeroSorte" class="fa fa-spinner fa-spin"></i>
          </button>
        </form>
      </div>

      <ng-template #numeroGeradoComSucesso>
        <div class="numero__gerado">
          <img class="gerado__icone" src="assets/images/icons/coracao_check.png" alt="Número gerado com sucesso" />
          <div>
            <p class="gerado__mensagem">
              <b>Pronto!</b>
            </p>
            <p class="gerado__mensagem">
              Seu número da sorte foi gerado, boa sorte!
            </p>
          </div>
        </div>
      </ng-template>
    </div>
  </lovers-popup>

  <!-- Regulamento -->
  <lovers-popup [exibir]="exibirModalRegulamento" (onClose)="exibirModalRegulamento = false">
    <div class="popup__header">
      <p class="header__title">Promoção Dia dos Namorados</p>
    </div>
    <div class="popup__body">
      <p class="regulamento__titulo">Confira o regulamento e participe!</p>
      <div class="regulamento__texto regulamento__container">
        <p *ngFor="let paragrafo of regulamento">
          {{ paragrafo }}
        </p>
      </div>
    </div>
  </lovers-popup>

  <!-- Número Sorte -->
  <lovers-popup [exibir]="numeroSorteSelecionado !== undefined" (onClose)="numeroSorteSelecionado = undefined"
    [tamanho]="numeroSorteSelecionado?.pincode ? 'pequeno' : 'normal'">
    <div *ngIf="numeroSorteSelecionado !== undefined">
      <div class="popup__header popup__numero-sorte">
        <img class="icone__sorte" src="assets/images/icons/coracao_pequeno.png" lass="numero-sorte__icone" />
        <div>
          <p class="numero-sorte__titulo">Número da Sorte</p>

          <p class="numero-sorte__numeros">
            <span class="numeros__numero-sorte" *ngFor="
                let bilheteCompra of numeroSorteSelecionado.sorteioParticipantesComprasBilhetesModel!
              ">
              {{ bilheteCompra.serie }}-{{ bilheteCompra.number }}
            </span>
          </p>
        </div>
      </div>

      <div class="popup__body numero__sorte__modal">
        <div *ngIf="numeroSorteSelecionado.pincode">
          <p class="gerado-por-cupom">Gerado por cupom promocional</p>
          <small>{{ numeroSorteSelecionado.numeroPincode }}</small>
        </div>

        <div *ngIf="!numeroSorteSelecionado.pincode">
          <div class="compra__info">
            <div>
              <p class="info__titulo">Compra</p>
              <p class="info__valor">
                {{ numeroSorteSelecionado.data | date : "dd/MM/yyyy" }}
              </p>
            </div>

            <div>
              <p class="info__titulo">Valor</p>
              <p class="info__valor">
                {{ numeroSorteSelecionado.valor | currency : "R$" }}
              </p>
            </div>

            <div>
              <p class="info__titulo">Loja</p>
              <p class="info__valor">
                {{ numeroSorteSelecionado.loja | titlecase }}
              </p>
            </div>
          </div>

          <div class="compra__produtos">
            <p class="produtos__titulo">Produtos</p>
            <div class="produtos__produto" *ngFor="
                let produto of numeroSorteSelecionado.sorteioParticipantesComprasItensModel
              " [hidden]="produto.descricao === ''">
              <p class="produto__nome">
                {{ produto.quantidade }} {{ produto.descricao | titlecase }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </lovers-popup>

  <!-- Ganhadores -->
  <lovers-popup [exibir]="exibirModalGanhadores" (onClose)="exibirModalGanhadores = false">
    <div class="popup__header">
      <p class="header__title">Ganhadores</p>
    </div>
    <div class="popup__body">
      <div class="ganhadores__input__container">
        <img src="assets/images/icons/search_regular.png" class="input-icon" />
        <input class="lp-input" type="text" [(ngModel)]="filtroGanhadorNome" placeholder="Procurar nome" />
      </div>

      <table class="ganhadores__table">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Nº da Sorte</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let ganhador of filtrarGanhadores()">
            <td>{{ ganhador.nomeAbreviado }}</td>
            <td>{{ ganhador.bilhete }}</td>
          </tr>
        </tbody>
      </table>

      <div class="ganhadores__container__mobile">
        <div class="ganhadores__ganhador" *ngFor="let ganhador of filtrarGanhadores()">
          <p class="ganhador__propriedade"><b>Nome:</b> {{ ganhador.nome }}</p>
          <p class="ganhador__propriedade">
            <b>Nº da Sorte:</b> {{ ganhador.bilhete }}
          </p>
          <!-- <p class="ganhador__propriedade"><b>Loja:</b> {{ ganhador.loja }}</p> -->
        </div>
      </div>

      <ngx-skeleton-loader *ngIf="obtendoGanhadores" count="3" [theme]="{
          'border-radius': '8px',
          width: '100%',
          height: '48px',
          margin: '8px 0 0'
        }"></ngx-skeleton-loader>
    </div>
  </lovers-popup>

  <lovers-popup [exibir]="exibirModalVerificacao" (onClose)="exibirModalVerificacao = false">
    <div class="popup__header">
      <p class="header__title">Quase lá...</p>
    </div>
    <div class="popup__body">
      <p>Para participar da promoção, o seu e-mail e telefone devem estar validados</p>

      <button class="lovers-button modal__validar__button" (click)="irParaValidaDados()">
        Validar dados
      </button>
    </div>
  </lovers-popup>
  <!-- Verificação de Dados -->
</div>



<!-- Localização Lojas -->
<app-localizacao (fecharCardLocalizacao)="exibirModalLocalizacao = false" [exibirModal]="exibirModalLocalizacao"
  [idExperiencia]="idExperienciaLocalizacao">
</app-localizacao>
